/** 终审容器（SC / IOC）可选的容器类型：容器卡片的下拉和预览里的显示共用 */
export const CONTAINER_TYPES = [
  { value: 'box', label: '箱子' },
  { value: 'pallet', label: '托盘' },
  { value: 'shipping_bag', label: '物流袋' },
  { value: 'tote_bag', label: '仓库周转袋' },
  { value: 'direct', label: '直接存储' },
  { value: 'cart', label: '移动车' },
  { value: 'other', label: '其他' },
];

export const containerTypeText = (value?: string) => CONTAINER_TYPES.find(t => t.value === value)?.label || value || '-';
